<template>
	<div class="page__package-form" :key="`${currentPackage}`">
		<div class="back-to-home rounded d-none d-sm-block">
			<a href="https://brevisvelox.com" class="btn btn-icon btn-soft-primary">
				<font-awesome-icon icon="home" />
			</a>
		</div>
		<section class="d-flex flex-column h-100 align-items-center">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col col-md-6 px-0 px-md-2">
						<div class="page__package-form__image-wrapper" v-if="currentPackage.form_img">
							<img
								:src="helperImgPath(currentPackage.form_img)"
								class="img-fluid"
								:alt="currentPackage.title"
							/>
						</div>
					</div>
				</div>
				<div class="row justify-content-center my-4">
					<div class="col col-md-10 col-lg-8 col-xl-7 d-flex flex-column">
						<div class v-html="currentPackage.form_text"></div>
						<FormulateForm @submit="onSubmit" :schema="currentPackage.form" v-model="formFields">
							<FormulateInput type="submit" name="Na raziskavo" class="mt-3" />
						</FormulateForm>
					</div>

					<!--end col-->
				</div>
				<!--end row-->
				<ProgressBarContainer>
					<template #header>
						<p>
							Sklop
							<span>1</span>
							od
							{{ packageLength }}
						</p>
					</template>
					<template #bar>
						<b-progress
							:value="1"
							:max="packageLength"
							height="0.5rem"
							variant="primary"
							class="rounded w-100"
						></b-progress>
					</template>
				</ProgressBarContainer>
			</div>
			<!--end container-->
		</section>
		<!--end section-->
	</div>
</template>
<script>
import ProgressBarContainer from "@/components/ProgressBarContainer.vue"
import axios from "axios"
import { mapGetters } from "vuex"

import moment from "moment"
moment.locale("en")

export default {
	components: {
		ProgressBarContainer
	},
	data() {
		return {
			loading: true,
			formFields: {},
		}
	},
	computed: {
		...mapGetters({
			currentPackage: "api/getCurrentPackage",
			packageProjects: "api/getPackageProjects",
			respondentId: "api/getRespondentId",
			packageLength: "api/calcPackageLength",
		}),
	},

	created() {
		if (!this.respondentId || !this.currentPackage) {
			this.$router.push({
				name: "Package",
				params: { package: this.$route.params.packageSlug },
			})
		}
	},
	mounted() { },
	methods: {
		onSubmit() {
			this.isSending = true

			return new Promise((resolve, reject) => {
				axios({
					url: `${this.$store.state.login.url}/api/package/${this.currentPackage.id}/respondents/${this.respondentId}/formdata`,
					headers: {
						Authorization: `Bearer ${this.$store.state.login.token}`,
						"Content-Type": "application/json",
					},
					data: JSON.stringify(this.formFields),
					method: "POST",
				})
					.then((response) => {
						let nextProjectSlug = this.packageProjects[0].data.random_slug

						// cleanup form
						this.isSending = false

						this.$store.commit("api/respondent_success", response.data.id)
						this.$store.dispatch("api/fetchProject", nextProjectSlug)

						this.$router.push({
							name: "IntroPagePackage",
							params: {
								packageSlug: this.currentPackage.slug,
								projectSlug: nextProjectSlug,
							},
						})
						resolve(response)
					})
					.catch((err) => {
						this.isSending = false
						this.$bvToast.toast(err.message, {
							title: "Something went wrong ... ",
							autoHideDelay: 5000,
						})
						reject(err)
					})
			})
		},
		helperImgPath: function (img) {
			return `${this.$store.state.api.url}/uploads/package-${this.currentPackage.id}/help_images/${img}`
		},
	},
}
</script>
<style>
.formulate-input {
	margin-bottom: 0.5em !important;
}
</style>
